.headerWrapper {
  background-color: var(--tuna-palette-layers);
  opacity: 0.6;
  transition: opacity 0.3s;
}

.headerWrapper:hover {
  opacity: 1;
}

.header {
  display: grid;
  grid-template-columns: 1fr 1fr 1fr;
  column-gap: 8px;
  justify-items: center;
  align-items: center;
  padding: 4px 8px;
}

.structureMapSlot {
  display: flex;
  justify-content: center;
  padding: 0 8px;
}

.structureMapSlot:empty {
  display: none;
}

.leftSection {
  justify-self: flex-start;
}

.autoscrollBox {
  margin-left: 16px;
  align-items: center;
}

.durationText {
  margin-left: 4px;
  min-width: 40px;
}

.rhythmContainer {
  white-space: nowrap;
}

.rhythmSection {
  justify-content: flex-end;
  margin-right: 16px;
}

/* The rhythm reads as text; it is not a control (it used to open Settings) */
.rhythmText {
  margin-left: var(--tuna-spacing-1);
}

.rightSection {
  justify-self: flex-end;
  align-items: center;
  gap: 4px;
}

/* The part menu, Shapes | Concert, My notes and Display read in sentence case, like the song top bar
 * ("Playing Vocals + Guitar"), and each stays on one line: a two-line control in a one-line header reads as broken */
.rightSection button {
  text-transform: none;
  white-space: nowrap;
}

/*
 * Below the 1200 breakpoint the controls (part menu, Shapes | Concert, My notes, Display) do not fit in a
 * third of the header beside a long part line: they take their own row, right-aligned, and the part line
 * may wrap (it is text, not a control), so neither runs off the screen.
 */
@media (max-width: 1199.95px) {
  .header {
    grid-template-columns: auto minmax(0, 1fr);
    row-gap: var(--tuna-spacing-0_5);
  }

  .rhythmSection {
    min-width: 0;
  }

  .rhythmContainer {
    white-space: normal;
  }

  .rightSection {
    grid-column: 1 / -1;
    max-width: 100%;
    flex-wrap: wrap;
    justify-content: flex-end;
  }

  /* Never squeeze a control's label. If the row is still too wide it wraps: a scrolled row hides Display */
  .rightSection > * {
    flex-shrink: 0;
  }
}
